<template>
  <div>
    <SysDialog
      v-model="dialog"
      :largura="800"
      titulo="Estoque de segurança por produto"
      @click:primary="salvarEsseg()"
      @click:hidden-dialog="$emit('fechar-dialog-produtos', false)"
    >
      <SysDataTable
        :headers="headers"
        :items="desserts"
        :height="alturaDaJanela - 350"
        :item-height="40"
        :search="search"
        hide-default-footer
      >
        <template #top>
          <v-spacer />

          <v-text-field
            v-model="search"
            outlined
            dense
            class="mb-2"
            append-icon="mdi-magnify"
            label="Pesquisar"
            single-line
            hide-details
          />
        </template>

        <template #item.tempo_cobertura_esseg="{ item }">
          <TextFieldFormatadorDeValor
            v-model="item.tempo_cobertura_esseg"
            class="input-cobertura-estoque-seguranca text-field-centralizado"
            dense
            hide-details
            suffix="dias"
            @focus="$event.target.select()"
            @keyup.enter="salvarEsseg()"
          />
        </template>
      </SysDataTable>
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import SysDataTable from '@/components/utils/dataTable/sysDataTable/Index.vue';
import Responsividade from "@/helpers/ResponsiveHeight";
import TextFieldFormatadorDeValor from '@/components/utils/TextFieldFormatadorDeValor.vue';
import { buscarProdutosFornecedor, salvarEssegProdutoFornecedor } from "./RequisicoesAPI";

export default {
  name: "Produtos",
  mixins: [Responsividade],
  components: { SysDialog, SysDataTable, TextFieldFormatadorDeValor },
  props: {
    cobertura_selecionada: {
      type: Number
    },
    fornecedor: {
      type: Object,
      required: true,
      default: null
    }
  },
  data: () => ({
    dialog: false,
    headers: [
      { text: 'ID Produto', value: 'idproduto' },
      { text: 'Descrição Produto', value: 'descricao_produto' },
      { text: 'Cobertura', value: 'tempo_cobertura_esseg', style: { width: '100px'} }
    ],
    desserts: [],
    search: '',
    cobertura_esseg: null
  }),
  watch: {
    cobertura_selecionada(valor) {
      const validador = valor === 4;
      this.dialog = validador;
      if (validador) {
        const parametros = {
          id_fornecedor: this.fornecedor.id,
          ativar_grupo_economico_compra: this.fornecedor.grupo_analise_fornecedores ? 'S' : 'N'
        }

        this.$store.dispatch(
          "loading/addRequisicao",
          buscarProdutosFornecedor(parametros)
            .then(dado => this.desserts = dado)
            .catch(() => this.Helpers.logout())
        );
      }
    },
  },
  methods: {
    salvarEsseg() {
      const params = {
        id_grupo: this.$store.getters['usuario/getGrupoCompras'],
        id_fornecedor: this.fornecedor.id,
        tipo_esseg: this.cobertura_selecionada,
        valor_esseg: this.cobertura_esseg,
        produtos: this.desserts,
        ativar_grupo_economico_compra: this.fornecedor.grupo_analise_fornecedores ? 'S' : 'N'
      }

      this.$store.dispatch(
        "loading/addRequisicao",
        salvarEssegProdutoFornecedor(params)
          .then(() => {
            this.dialog = false;
            this.$emit('fechar-dialog-produtos', true);
          })
          .catch(() => this.Helpers.logout())
      )
    }
  }
}
</script>

<style>
.input-cobertura-estoque-seguranca {
  text-align: center;
  width: 80px;
  font-size: 12px;
}
</style>
